import React from "react";
import { Route, Routes } from "react-router-dom";
import ConsoleShell from "./ConsoleShell";
import LegacyPlatformRedirect from "./LegacyPlatformRedirect";
import WorkspaceDetailPage from "./WorkspaceDetailPage";
import PlatformWorkspaceCreatePage from "./PlatformWorkspaceCreatePage";
import PlatformPresencePage from "./PlatformPresencePage";
import PlatformConsoleSectionGate from "./PlatformConsoleSectionGate";
import { PlatformConsoleAclProvider } from "./PlatformConsoleAclContext";
import { PLATFORM_CONSOLE_SEGMENT } from "./platformConsoleRoutes";
import {
  WorkspacesSectionPage,
  InsightsSectionPage,
  OpportunitiesSectionPage,
  SegmentsSectionPage,
  GovernanceSectionPage,
  CatalogSectionPage,
} from "./PlatformConsoleSectionPages";

/**
 * Console da plataforma (master xprobase). Rotas sob /platform/xprobase/*
 * Navegação por seções (drawer) + ?tab= legado redirecionado no index.
 */
const PlatformXprobaseConsole = () => {
  return (
    <PlatformConsoleAclProvider>
      <Routes>
        <Route element={<ConsoleShell />}>
          <Route index element={<LegacyPlatformRedirect />} />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.workspaceCreate}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.workspaces}>
                <PlatformWorkspaceCreatePage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={`${PLATFORM_CONSOLE_SEGMENT.workspaces}/:dominioId/:section?`}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.workspaces}>
                <WorkspaceDetailPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.workspaces}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.workspaces}>
                <WorkspacesSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.opportunities}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.opportunities}>
                <OpportunitiesSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.insights}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.insights}>
                <InsightsSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.presence}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.presence}>
                <PlatformPresencePage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.segments}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.segments}>
                <SegmentsSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.governance}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.governance}>
                <GovernanceSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
          <Route
            path={PLATFORM_CONSOLE_SEGMENT.catalog}
            element={
              <PlatformConsoleSectionGate section={PLATFORM_CONSOLE_SEGMENT.catalog}>
                <CatalogSectionPage />
              </PlatformConsoleSectionGate>
            }
          />
        </Route>
      </Routes>
    </PlatformConsoleAclProvider>
  );
};

export default PlatformXprobaseConsole;
